import { isAdminLikeRole } from '@/lib/roles';
import { AdvanceFilter, AdvanceFilterFieldType, AdvanceFilterOperator } from '@/types/types';

export const getDefaultTeamFilters = (
  user: { roleId?: string | null } | null | undefined,
  lockedTeamId?: string | null
): AdvanceFilter[] => {
  if (isAdminLikeRole(user?.roleId)) return [];
  return [
    {
      field: 'teamId',
      operator: AdvanceFilterOperator.EQUALS,
      value: lockedTeamId ?? 'MY_TEAMS',
      fieldType: AdvanceFilterFieldType.ID,
    },
  ];
};
